var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStickLtr = function SvgStickLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 29.25v2.5h-19v-2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M61 8a2 2 0 0 0-2-2H43a2 2 0 0 0-2 2v84a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2zm-15.5 2.5h11v79h-11z",
    clipRule: "evenodd"
  })));
};
export default SvgStickLtr;